import * as types from './constants';

// Get Group
export const getGroupRequest = data => (
  { type: types.GET_GROUP_REQUEST, payload: data }
);

export const getGroupDone = data => (
  { type: types.GET_GROUP_DONE, payload: data }
);

export const getGroupFailed = errors => (
  { type: types.GET_GROUP_FAILED, payload: errors }
);

// Update Group
export const updateGroupRequest = data => (
  { type: types.UPDATE_GROUP_REQUEST, payload: data }
);

export const updateGroupDone = data => (
  { type: types.UPDATE_GROUP_DONE, payload: data }
);

export const updateGroupFailed = errors => (
  { type: types.UPDATE_GROUP_FAILED, payload: errors }
);

export const updateGroupReset = errors => (
  { type: types.UPDATE_GROUP_RESET, payload: errors }
);